import { FormControl, FormGroup } from "@angular/forms";
import { createLandAreaFormGroup, LandAreaFormGroup } from "../land-areas/form-group";

export type ParcelIdentificationFormGroup = FormGroup<{
  add_info_on_land: FormControl<boolean>,
  land_parcel_name: FormControl<string>,
  boundary_type: FormControl<number>,
  coordinate_reference_system_id: FormControl<number>,
  land_area: LandAreaFormGroup,
}>

export function createParcelIdentificationFormGroup(payload: {
  addInfoOnLand: boolean,
  landParcelName: string | null,
  boundaryType: number,
  coordinateReferenceSystemId: number | null
  landArea: {
    planningStatusId: number | null,
    qosDegradationId: number | null,
    envConsiderations: string | null,
    otherConsiderations: string | null,
    plotArea: number | null
  },
}): ParcelIdentificationFormGroup {
  return new FormGroup({
    add_info_on_land: new FormControl<boolean>(payload.addInfoOnLand),
    land_parcel_name: new FormControl<string|null>(payload.landParcelName),
    boundary_type: new FormControl<number>(payload.boundaryType),
    coordinate_reference_system_id: new FormControl<number|null>(payload.coordinateReferenceSystemId),
    land_area: createLandAreaFormGroup(payload.landArea),
  })
}